import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalTypesComponent } from 'app/components/shared/modals-types/modal-types.component';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { CombosConfiguration, FunctionsService, HttpService, LocalStorageService, MessageService, params, SessionService, TableColumns, TableConfiguration } from 'brainloper-ui';
import { InputOrOutputInventory } from 'app/models2/inventory/input-or-output-inventory';
import { HistoryInventory } from 'app/models2/inventory/history-inventory';
import { User } from 'app/models2/administration/user';
import { Item } from 'app/models2/inventory/item';
import { Provider } from 'app/models2/administration/provider';
import { ItemComboLength } from 'app/models2/inventory/item-combo-length';
import { Warehouse } from 'app/models2/inventory/warehouse';
import { enumWorkOrderStates, WorkOrder } from 'app/models2/maintenance/work-order';
import { enumProviderType } from 'app/models2/commos/enum-provider-type';
import { PurchaseOrder } from 'app/models2/inventory/purchase-order';
import { RentalOrder } from 'app/models2/rental/rental-order';

@Component({
  selector: 'app-handler-items',
  templateUrl: './handler-items.component.html',
  styleUrls: ['./handler-items.component.scss']
})
export class HandlerItemsComponent implements OnInit, OnChanges {

  @Input() addNewItem: boolean = false
  @Input() addProvider: boolean = false
  @Input() addWarehouse: boolean = true
  @Input() addRentalOrder: boolean = false
  @Input() comboWorkOrder: boolean = false
  @Input() showDate: boolean = true
  @Input() showTotal: boolean = true
  @Input() showAmount: boolean = true
  @Input() openDialog: boolean = true
  @Input() showReplyButton: boolean = true
  @Input() showPrintButton: boolean = false
  @Input() showCurrentAmount: boolean = true
  @Input() showUnitMeasurement: boolean = true
  @Input() showPurchaseOrder: boolean = false
  @Input() showAddItemButton: boolean = true
  @Input() showRemoveItemButton: boolean = true
  @Input() labelCodigo: string = 'Código'
  @Input() titleDialog: string = ''
  @Input() addCurrentAmount: boolean = false
  @Input() replyRoute: string = null
  @Input() headerDetails: boolean = true
  @Input() acceptButton: boolean = false
  @Input() labelAcceptButton: string = 'Aceptar'
  @Input() itemsData: Array<InputOrOutputInventory> = [];
  @Input() workOrderData: WorkOrder = {};
  @Input() editHistoryInventory: HistoryInventory
  @Input() addReceptionDate: boolean = false
  @Input() addAuthorize: boolean = false
  @Input() editCostItem: boolean = false
  @Input() initializeEmptyItem: boolean = false
  @Input() urlItemCombo: string = ""
  @Input() fromPackOff: boolean = false
  @Input() workOrderState: enumWorkOrderStates = enumWorkOrderStates.IN_EXECUTION
  @Input() view: boolean = true
  @Input() paramsWarehouse: params[] = [{ id: 'active', value: 1 }];
  @Input() paramsRentalOrder: params[] = [];
  @Input() rentalorderId: number = null
  @Input() showDeleteItem: boolean = true


  @Output() listItemComplete = new EventEmitter<HistoryInventory>()
  @Output() comboItemLength = new EventEmitter<ItemComboLength>()
  @Output() goBackButton = new EventEmitter<true>()
  @Output() printButton = new EventEmitter<number>()

  public today: string
  public providerId: number = -1
  public warehouseId: number = -1
  public purchaseOrderId: number = null
  public currentUser:number = this.storage.get('userId') ?? 0
  public userAuthorizeId: number = this.currentUser
  public total: number = -1
  public labels = ['Total: $ 0']
  public buttonActive: boolean = false
  public receptionDate: string | Date
  public isMobile: boolean = screen.width > 800 ? true : false;
  public workOrderId: number = null
  public hasOneWarehouse: boolean = false
  showProvider: boolean = true



  public firstInRow = [{ id: 0, consecutive: 'No Asociar Orden' }]
  public paramsProvider: params[] = [{ id: 'providerTypeId', value: enumProviderType.ALMACEN }];

  public paramsPurchaseOrderByState: params[] = [{ id: 'providerId', value: 0 }, { id: 'stateId', value: 2 }, { id: 'warehouseId', value: 0 }];
  public paramsWorkOrderByState: params[] = [{ id: 'active', value: 1 }, { id: 'authorized', value: 1 }, { id: 'readyResources', value: 1 }];
  private paramsItemsCombo: params[] = [{ id: 'warehouseId', value: 0 }]
  public comboDataWarehouse: Warehouse[] = []

  public comboDataProvider: Array<Provider> = []
  public comboDataUser: Array<User> = []
  public comboDataItems: Array<Item> = []
  public comboPurchaseOrder: boolean = true
  public comboItemsByWarehouse: any = {}

  public comboConfigWarehouseByItem: CombosConfiguration[] = []
  public reloadComboWarehouseByItem: Array<EventEmitter<any>> = []

  public comboConfigItems: Array<CombosConfiguration> = []
  public reloadComboItems: Array<EventEmitter<any>> = []

  public reloadComboProvider = new EventEmitter<any>();
  public comboConfigProvider: CombosConfiguration = {
    visibleField: 'providerName',
    selectionField: 'id',
    urlCombo: EndpointDictionary.Provider.PROVIDER_TYPE_COMBO,
    urlParams: this.paramsProvider,
    label: 'Proveedor',
  }

  public reloadComboWarehouse = new EventEmitter<any>();
  public comboConfigWarehouse: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'id',
    urlCombo: EndpointDictionary.Warehouse.WAREHOUSE_COMBO,
    urlParams: this.paramsWarehouse,
    label: 'Bodega',
  }

  public reloadComboPurchaseOrderByState = new EventEmitter<any>();
  public comboConfigPurchaseOrderByState: CombosConfiguration = {
    visibleField: 'consecutive',
    selectionField: 'id',
    urlCombo: EndpointDictionary.PurchaseOrder.PURCHASE_ORDER_COMBO_STATE,
    urlParams: this.paramsPurchaseOrderByState,
    label: 'Orden de Compra',
  }

  public reloadComboWorkOrderByState = new EventEmitter<any>();
  public comboConfigWorkOrderByState: CombosConfiguration = {
    visibleField: 'consecutive',
    selectionField: 'id',
    urlCombo: EndpointDictionary.WorkOrder.WORK_ORDER_COMBO_STATE,
    urlParams: this.paramsWorkOrderByState,
    label: 'Orden de Trabajo'
  }

  public reloadComboRentalOrder = new EventEmitter<any>();
  public comboConfigRentalOrder: CombosConfiguration = {
    visibleField: 'consecutive',
    selectionField: 'id',
    urlCombo: EndpointDictionary.RentalOrder.RENTAL_ORDER_COMBO_STATE,
    urlParams: this.paramsRentalOrder,
    label: 'Orden de Alquiler'
  }

  public comboConfigUserAutorize: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'userId',
    urlCombo: EndpointDictionary.User.USER_COMBO,
    urlParams: [],
    label: 'Autoriza',
    selected: this.currentUser
  }

  constructor(
    private functionEter: FunctionsService,
    private message: MessageService,
    private storage: LocalStorageService,
    public dialog: MatDialog,
    public router: Router,
    public http: HttpService,
    private session: SessionService,
    private activeRoute: ActivatedRoute,
  ) {

  }

  async ngOnInit() {
    this.message.openLoading("Cargando", "Cargando información")
    this.today = this.functionEter.dateDB(new Date())

    this.comboConfigWarehouse.urlParams = this.paramsWarehouse
    this.comboConfigRentalOrder.urlParams = this.paramsRentalOrder

    if (this.fromPackOff) {
      this.comboDataWarehouse = await this.http.getDataBody(EndpointDictionary.Warehouse.WAREHOUSE_COMBO, this.paramsWarehouse)
      return
    }

    this.activeRoute.queryParamMap
      .subscribe(async (params) => {
        const warehouseId = params.get('warehouseId');
        this.setWarehouse(warehouseId != null ? parseInt(warehouseId) : null)
      })


    if (this.initializeEmptyItem == true) {
      this.initializeItemData()
    }
    this.message.closeLoading()
  }


  ngOnChanges(changes: SimpleChanges) {
    if (!changes) return
    if (changes['editHistoryInventory'] && this.editHistoryInventory) {
      this.initializeHistoryInventoryData()
    }
    if (changes['itemsData']) {
      this.editItems()
    }
    if (changes['workOrderState'] && this.workOrderState == enumWorkOrderStates.TO_DISPATCH && this.workOrderData?.id) {
      this.paramsWorkOrderByState[2].value = 0
      this.comboConfigWorkOrderByState.selected = this.workOrderData.id
      this.reloadComboWorkOrderByState.emit()
    }
  }

  initializeItemData() {

    this.comboConfigItems = [
      {
        visibleField: 'itemName',
        selectionField: 'id',
        label: 'Item',
      }
    ]
    this.reloadComboItems = [
      new EventEmitter<any>()
    ]
    this.itemsData = [
      {
        itemInventoryId: null,
        amount: 0,
        unitMeasurement: null,
        code: null,
        costItem: null,
        totalCost: null,
        currentAmount: null
      }
    ]
  }

  initializeHistoryInventoryData() {
    if (this.addAuthorize) {
      this.comboConfigUserAutorize.selected = this.editHistoryInventory.authorize
      this.userAuthorizeId = this.editHistoryInventory.authorize
    }
    if (this.addProvider) {
      this.comboConfigProvider.selected = this.editHistoryInventory.providerId
      this.providerId = this.editHistoryInventory.providerId
    }
    if (this.addReceptionDate) {
      this.receptionDate = new Date(this.editHistoryInventory.receptionDate) as Date
    }
    this.itemsData = this.editHistoryInventory.items
    this.editItems()
  }

  async editItems() {
    if (this.itemsData.length == 0) {
      this.initializeItemData()
      return
    }
    if (this.itemsData[0]?.itemInventoryId) {

      this.comboConfigItems = []
      this.reloadComboItems = []
      if (this.fromPackOff) {
        this.comboConfigWarehouseByItem = []
        this.reloadComboWarehouseByItem = []
      }
      for (let [index, item] of this.itemsData.entries()) {

        if (item.warehouseId && !this.comboItemsByWarehouse[item.warehouseId.toString()]) {
          this.paramsItemsCombo[0].value = item.warehouseId
          let itemsW: Item[] = await this.http.getDataBody(this.urlItemCombo, this.paramsItemsCombo);
          this.comboItemsByWarehouse[item.warehouseId.toString()] = itemsW
        }

        if (this.fromPackOff) {
          this.comboConfigWarehouseByItem.push(
            {
              visibleField: 'name',
              selectionField: 'id',
              label: 'Bodega',
              selected: item.warehouseId
            }
          )
          this.reloadComboWarehouseByItem.push(
            new EventEmitter<any>()
          )
          this.reloadComboWarehouseByItem[index].emit('selected')
        }

        this.comboConfigItems.push(
          {
            visibleField: 'itemName',
            selectionField: 'id',
            label: 'Item',
            selected: item.itemInventoryId
          }
        )
        this.reloadComboItems.push(
          new EventEmitter<any>()
        )
        this.reloadComboItems[index].emit('selected')
        this.keyUpAmout(index, true)
      }
    }
    this.message.closeLoading()
  }

  async valueIDItem($event: number, index: number) {
    let existingItem = this.itemsData.find(x => x.itemInventoryId == $event)
    if (!this.fromPackOff && existingItem) {
      this.message.Warning("Advertencia", "Item ya seleccionado")
      this.deleteItemsData(index)
      return
    }

    let existingItemByWarehouse = this.itemsData.find(x => x.itemInventoryId == $event && x.warehouseId == this.itemsData[index].warehouseId);
    if (this.fromPackOff && existingItemByWarehouse) {
      this.message.Warning("Advertencia", "Item y Bodega ya seleccionados");
      this.deleteItemsData(index);
      return;
    }

    let item = this.comboDataItems.find(x => x.id == $event)
    if (item) {
      this.itemsData[index].itemInventoryId = $event
      this.itemsData[index].unitMeasurement = item.unitMeasurement
      this.itemsData[index].code = item.code
      this.itemsData[index].costItem = item.costItem
      this.itemsData[index].itemName = item.itemName
      this.itemsData[index].currentAmount = item.amount

      if(!this.showAmount){
        this.itemsData[index].amount = 1
        this.suma()
      }
    }

  }

  async addNew(type: string, index: number) {
    let size: number = screen.width > 500 ? 60 : 50;

    const dialogRef = this.dialog.open(ModalTypesComponent, {
      width: `${size}vh`,
      data: { name: type },
    });

    dialogRef.afterClosed().subscribe(async (result) => {

      switch (type) {
        case 'item':
          this.comboDataItems = await this.http.getDataBody(this.urlItemCombo, this.paramsItemsCombo);
          break;
      }
    });

  }

  async valueProvider($event: number) {
    if ($event && $event > 0) {
      this.comboPurchaseOrder = true
      this.providerId = $event
      this.paramsPurchaseOrderByState[0].value = this.providerId
      this.paramsPurchaseOrderByState[2].value = this.warehouseId
      this.reloadComboPurchaseOrderByState.emit();
    }

  }

  async valueWarehouse($event: Warehouse) {
    const { id, typeId } = $event;
    this.setWarehouse(id)
    if (this.comboWorkOrder) {
      this.comboConfigWorkOrderByState.selected = -1
      this.reloadComboWorkOrderByState.emit('selected');
    }
    if (!this.editHistoryInventory) this.initializeItemData()
  }

  async valueWarehouseByItem($event: Warehouse, index: number) {
    let previusWarehouseId = this.itemsData[index].warehouseId
    this.itemsData[index].warehouseId = $event.id
    this.itemsData[index].warehouse = $event.name

    await this.setWarehouse($event.id, index)
    if (this.itemsData[index].itemInventoryId) {
      let item: Item = this.comboItemsByWarehouse[$event.id.toString()].find(x => x.id == this.itemsData[index].itemInventoryId)
      if (item && item.amount >= this.itemsData[index].amount) {
        this.itemsData[index].currentAmount = item.amount
        this.itemsData[index].warehouse = $event.name
      } else {
        await this.setWarehouse(previusWarehouseId, index)
        this.itemsData[index].warehouseId = previusWarehouseId
        this.message.Warning("Advertencia", `Cantidad Insuficiente de ${item.itemName} en Bodega ${$event.name}`)
      }
    }
  }

  async changesComboPurchaseOrder($event: number) {
    this.message.openLoading('Cargando', 'Cargando información')
    if ($event && $event > 0) {
      this.purchaseOrderId = $event
      let res = await this.http.getDataBody<Array<HistoryInventory>>(`${EndpointDictionary.PurchaseOrder.CRUD_PURCHASE_ORDER}/${this.purchaseOrderId}`)
      if (res) {
        this.itemsData = res[0].items
        this.editItems()
      }
    } else {
      this.purchaseOrderId = null

      this.initializeItemData()
    }
    this.message.closeLoading()
  }


  dataComboProvider($event: Array<Provider>) {
    this.comboDataProvider = $event
  }

  dataComboPurchaseOrder($event: PurchaseOrder[]) {
    if ($event.length > 1) {
      this.comboPurchaseOrder = true
    } else {
      this.comboPurchaseOrder = false
    }
  }

  async dataComboWarehouse($event:Warehouse[]) {
    if ($event.length === 1) {
      this.hasOneWarehouse = true
      this.warehouseId = $event[0].id
      this.comboConfigWarehouse.selected = this.warehouseId
      this.reloadComboWarehouse.emit('selected')
      await this.getComboItems()
    }
  }

  valueUser($event: number) {
    if ($event && $event > 0) {
      this.userAuthorizeId = $event
    }
  }

  dataComboUser($event: Array<User>) {
    this.comboDataUser = $event
  }

  async dataComboRentalOrder($event: RentalOrder[]){
    if(this.rentalorderId){
      var rentalOrder = $event.find(x => x.id == this.rentalorderId)
      if(rentalOrder){
        this.comboConfigRentalOrder.selected = this.rentalorderId
        this.reloadComboRentalOrder.emit('selected')
        this.changesComboRentalOrder(rentalOrder)
      }
    }
  }

  async changesComboRentalOrder($event: RentalOrder) {
    this.rentalorderId = $event.id
    this.itemsData = []
      for (const element of $event.equipments) {
        this.itemsData.push({
          itemInventoryId: element.equipmentId,
          costItem: element.rentalCost,
          totalCost: element.rentalCost,
          code: element.equipmentCode,
          amount: 1,
          itemName: element.equipmentName
        })
      }

    this.editItems()
    this.suma()
  }

  async changesComboWorkOrder($event: number) {
    if ($event && $event > 0) {
      this.workOrderId = $event
    } else {
      this.workOrderId = null
    }
  }

  errorMessage() {
    this.message.Error('Error!', 'Debe completar los campos del formulario')
  }

  handlerAddForm() {
    if (!this.fromPackOff) {
      if (this.itemsData.length == 0 || this.itemsData[this.itemsData.length - 1].itemInventoryId) {
        this.itemsData.push({
          itemInventoryId: null,
          amount: 0
        })
        this.comboConfigItems.push({
          visibleField: 'itemName',
          selectionField: 'id',
          label: 'Item',
        })
        this.reloadComboItems.push(
          new EventEmitter<any>()
        )
      }
    } else {
      if (this.itemsData.length == 0 || (this.itemsData[this.itemsData.length - 1].warehouseId && this.itemsData[this.itemsData.length - 1].itemInventoryId)) {
        this.itemsData.push({
          warehouseId: null,
          itemInventoryId: null,
          amount: 0
        })
        this.comboConfigWarehouseByItem.push({
          visibleField: 'name',
          selectionField: 'id',
          label: 'Bodega',
        })
        this.reloadComboWarehouseByItem.push(
          new EventEmitter<any>()
        )
        this.comboConfigItems.push({
          visibleField: 'itemName',
          selectionField: 'id',
          label: 'Item',
        })
        this.reloadComboItems.push(
          new EventEmitter<any>()
        )
      }
    }
  }

  deleteItemsData(index?: number, deleteById = false, itemInventoryId?: number) {
    if (index === undefined || index < 0) {
      index = this.itemsData.length - 1;
    }

    if (deleteById) {
      index = this.itemsData.findIndex(x => x.itemInventoryId == itemInventoryId)
    }

    if (index >= 0 && index < this.itemsData.length) {
      this.itemsData.splice(index, 1)
      this.comboConfigItems.splice(index, 1)
      this.reloadComboItems.splice(index, 1)
      this.comboConfigWarehouseByItem.splice(index, 1)
      this.reloadComboWarehouseByItem.splice(index, 1)
    }
    if (this.itemsData.length == 0) {
      this.handlerAddForm()
    }
    this.suma()
  }

  incompleteRequiredFields() {
    if (this.addAuthorize && this.addReceptionDate && this.addProvider && this.addWarehouse) {
      if (this.userAuthorizeId <= 0 || this.receptionDate == undefined || this.providerId <= 0 || this.warehouseId <= 0) {
        this.errorMessage()
        return true
      }
    }

    let itemSaveData = this.itemsData.find(x => x.amount <= 0)
    if (itemSaveData) {
      this.message.Error('Error!', 'La cantidad debe ser mayor a 0')
      return true
    }
    return false
  }

  openDialogFunction() {
    if(!this.openDialog){
      this.save()
      return
    }
    if (this.incompleteRequiredFields()) {
      return
    }
    let configurationDialog: TableConfiguration = {
      primaryKey: 'id'
    }
    let columnasDialog: TableColumns<InputOrOutputInventory>[] = [
      {
        ID: 'code',
        label: 'Código',
        type: 'text',
        style: {
          textAlign: 'center',
          movil: 'no-movil',
        },
      },
      {
        ID: 'itemName',
        label: 'Item',
        type: 'text',
        style: {
          textAlign: 'center',
        },
      }
    ]

    if(this.showAmount){
      columnasDialog.push({
        ID: 'amount',
        label: 'Cantidad',
        type: 'number',
        style: {
          textAlign: 'center'
        },
      });
    }

    if(this.showUnitMeasurement){
      columnasDialog.push( {
        ID: 'unitMeasurement',
        label: 'Unidad',
        type: 'text',
        style: {
          textAlign: 'center',
          movil: 'no-movil',
        },
      });
    }

    columnasDialog.push({
      ID: 'costItem',
      label: 'Costo',
      type: 'currency',
      style: {
        textAlign: 'center'
      },
    });

    if (this.fromPackOff) {
      let newColumnDialog: TableColumns<InputOrOutputInventory> = {
        ID: 'warehouse',
        label: 'Bodega',
        type: 'text',
        style: {
          textAlign: 'center',
          movil: 'no-movil',
        },
      }
      columnasDialog.splice(0, 0, newColumnDialog);
    }
    let data: DataDialog = {
      comment: this.editHistoryInventory?.comment,
      configurationDialog,
      columnasDialog,
      dataTable: JSON.parse(JSON.stringify(this.itemsData)),
      totalCost: this.total,
      titleDialog: this.titleDialog
    }


    const dialogRef = this.dialog.open(DialogDetailsList, {
      data,
      height: "70vh",
      width: "70vw"
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result[0]) {
        this.save(result)
      }
    });
  }

  save(result?: Array<boolean | string>) {
    if (this.itemsData[0].itemInventoryId > 0) {
      if (this.incompleteRequiredFields()) {
        return
      }
    }

    this.listItemComplete.emit({
      id: this.editHistoryInventory?.id ?? null,
      date: this.today,
      userId: this.storage.get<number>('userId'),
      items: this.itemsData.length == 1 && !this.itemsData[0].itemInventoryId ? [] : this.itemsData,
      providerId: this.providerId,
      authorize: this.userAuthorizeId,
      requests: this.storage.get<number>('userId'),
      active: 1,
      authorized: this.storage.get<number>('userId') == this.userAuthorizeId ? 1 : 0,
      stateId: this.storage.get<number>('userId') == this.userAuthorizeId ? 2 : 1,
      totalCost: this.total,
      receptionDate: this.addReceptionDate ? this.functionEter.dateDB(this.receptionDate) : null,
      orderId: this.editHistoryInventory?.orderId ?? this.workOrderId ?? null,
      comment: result ? result[1] as string : "",
      purchaseOrderId: this.purchaseOrderId ?? 0,
      warehouseId: this.warehouseId,
      rentalorderId: this.rentalorderId ?? 0
    })
  }

  keyUpAmout(index: number, deleteById = false) {
    setTimeout(() => {
      let item = this.itemsData[index]
      if (!item) return
      if (item.currentAmount >= item.amount || !this.addCurrentAmount) {
        item.totalCost = item.amount * item.costItem
        this.suma()
      } else {
        this.message.Warning("Advertencia", `Cantidad Insuficiente de ${item.itemName}, tiene actualmente ${item.currentAmount} ${item.unitMeasurement}`)
          .then(() => {
            item.amount = item.currentAmount
            item.totalCost = item.amount * item.costItem
            this.suma()
            if (item.currentAmount == 0) {
              this.deleteItemsData(index, deleteById, item.itemInventoryId)
            }
          })

      }
    }, 500);
  }

  replyRouteNavigate(){
    if(this.replyRoute) this.router.navigate([this.replyRoute])
    this.goBackButton.emit(true)
  }

  print(){
    this.printButton.emit(this.editHistoryInventory?.id)
  }

  suma() {
    this.total = 0
    for (const item of this.itemsData) {
      item.totalCost = item.amount * (item.costItem ?? 0)
      this.total += item.totalCost
      this.labels = [`Total: $  ${Intl.NumberFormat('es-CO').format(this.total)}`]
    }
  }

  private async getComboItems(): Promise<Item[]> {
    this.paramsItemsCombo[0].value = this.warehouseId ?? 0
    this.comboDataItems = await this.http.getDataBody(this.urlItemCombo, this.paramsItemsCombo)
    return this.comboDataItems
  }

  private async setWarehouse(warehouseId: number, i?: number) {
    this.warehouseId = warehouseId
    await this.getComboItems()

    if (warehouseId == null) {
      return
    }

    this.comboItemLength.emit({ length: this.comboDataItems.length, warehouseId: this.warehouseId });

    if (this.fromPackOff) {
      if (this.itemsData[i].warehouseId && !this.comboItemsByWarehouse[this.itemsData[i].warehouseId.toString()]) {
        this.comboItemsByWarehouse[this.itemsData[i].warehouseId.toString()] = this.comboDataItems
      }
      this.comboConfigWarehouseByItem[i].selected = this.warehouseId
      this.reloadComboWarehouseByItem[i].emit("selected")
      this.reloadComboItems[i].emit()
    } else {
      this.comboConfigWarehouse.selected = this.warehouseId
      this.reloadComboWarehouse.emit("selected")

      this.paramsPurchaseOrderByState[2].value = this.warehouseId

      this.comboConfigProvider.selected = this.editHistoryInventory ? this.editHistoryInventory.providerId : 0;
      this.reloadComboProvider.emit('selected')

      this.comboConfigPurchaseOrderByState.selected = -1
      this.reloadComboPurchaseOrderByState.emit('selected');
    }

  }

}

interface DataDialog {
  comment: string;
  configurationDialog: TableConfiguration;
  columnasDialog: Array<TableColumns<any>>;
  dataTable: Array<InputOrOutputInventory>;
  totalCost: number;
  titleDialog: string;
}


@Component({
  selector: 'dialog-details-list',
  templateUrl: './dialog-details-list.html',
})
export class DialogDetailsList {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DataDialog) {
    this.comment = data.comment ?? ""
  }
  public comment: string

}

